<template>
  <div class="svg-container">
    <svg id="background-gradient" preserveAspectRatio="xMidYMin slice" :viewBox="`0 0 ${size} ${size}`"  gradientUnits="userSpaceOnUse">
      <defs>
        <radialGradient id="grad1"
            :cx="`${radialGradiant1.cx}%`"
            :cy="`${radialGradiant1.cy}%`"
            :r="`${radialGradiant1.r}%`"
            :fx="`${radialGradiant1.fx}%`"
            :fy="`${radialGradiant1.fy}%`"
            gradient-units="userSpaceOnUse">
          <stop offset="0%" :stop-color="colorB"  stop-opacity="70%"/>
          <stop offset="90%" :stop-color="colorA" stop-opacity="40%" />
        </radialGradient>
        <radialGradient id="grad2"
            :cx="`${radialGradiant2.cx}%`"
            :cy="`${radialGradiant2.cy}%`"
            :r="`${radialGradiant2.r}%`"
            :fx="`${radialGradiant2.fx}%`"
            :fy="`${radialGradiant2.fy}%`"
            gradient-units="userSpaceOnUse">
          <stop offset="0%" :stop-color="'#F49B00'"  stop-opacity="100%" />
          <stop offset="100%" :stop-color="'#FFE662'" stop-opacity="100%" />
        </radialGradient>
      </defs>
      <rect :width="size" :height="size" fill="url(#grad1)" :style="{opacity:`${1 - opacity}`}"/>
      <rect :width="size" :height="size" fill="url(#grad2)" :style="{opacity:`${opacity}`}"/>
    </svg>
  </div>
</template>
<script lang="ts">
const size = 1440
const defaultRadial:radialGradient = {
  cx: 50,
  r: 150,
  fx: 50,
  cy: -50,
  fy: 0
}
</script>
<script setup lang="ts">
import { computed } from 'vue'
import { normalizeBetweenRange } from '../../utils'
export type radialGradient = {
  cx: number, // Abscisse ext circle.
  cy: number, // Ordonnée ext circle,
  r: number, // Rayon ext circle,
  fx: number, // Abscisse focal point,
  fy: number, // Ordonnée focal point,

}
export interface PropsBackgroundGradient {
  colorA?: string
  colorB?: string
  radialGradiant1?: radialGradient,
  radialGradiant2?: radialGradient,
  slider?: number
  min?: number
  max?: number
}


// https://developer.mozilla.org/fr/docs/Web/SVG/Element/radialGradient
const props = withDefaults(defineProps<PropsBackgroundGradient>(), {
  colorA: '#f49b00',
  colorB: '#FFE662',
  radialGradiant1: () => ({
      ...defaultRadial
    }),
  radialGradiant2: () =>  ({
    ...defaultRadial,
    cx: 30,
    fx: 50,
    r: 100,
    cy: 0,
    fy: 20
  }),
  slider: 50,
  min: 0,
  max: 100
})

const half = computed(() => (props.max - props.min) / 2)

const opacity = computed(() => {
  let normalize = 0
  if (props.slider > half.value) {
    const minOpacity = 0
    const maxOpacity = 1
    normalize = normalizeBetweenRange(props.slider,  {min: minOpacity, max: maxOpacity}, {min: half.value, max: props.max})
  }
  return normalize
})
</script>
<style lang="scss" scoped>
.svg-container {
  position: relative;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    min-height: 100%;
    min-width: 100%;
    overflow: hidden;
  }
}
</style>


